export default __webpack_public_path__ + "static/media/addphoto.84668c12.svg";